
/**
 * 트윗 내용 정보
 */
export type TweetCreateRequestMetadataContent = {
  /** @maxLength 280 */
  text: string;
};
